class GenericResultVM {
    
}